/** What the server derives for a link from `revokedAt` and `expiresAt`; it is never stored. */
export enum DocumentLinkStatusEnum {
  Active = 'Active',
  Expired = 'Expired',
  Revoked = 'Revoked',
}
